import React from 'react';

const Alert = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g id="alert-circle">
      <path
        id="Path"
        d="M9.1177 12C8.97106 12 8.85218 12.1119 8.85218 12.25C8.85218 12.3881 8.97106 12.5 9.1177 12.5C9.26435 12.5 9.38323 12.3881 9.38323 12.25C9.38323 12.1119 9.26435 12 9.1177 12V12"
        stroke="#C41A16"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Path_2"
        d="M9.1177 10V4.5"
        stroke="#C41A16"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        id="Oval"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.11803 16.5C13.5174 16.5 17.0837 13.1421 17.0837 9C17.0837 4.85786 13.5174 1.5 9.11803 1.5C4.7187 1.5 1.15234 4.85786 1.15234 9C1.15234 13.1421 4.7187 16.5 9.11803 16.5Z"
        stroke="#C41A16"
        strokeWidth="1.5"
      />
    </g>
  </svg>
);

export default Alert;
